export const enum CUSTOM_HEADERS {
  RECAPTCHA_TOKEN_HEADER = "x-mdr-recaptcha-token",
}
